module.exports = __webpack_public_path__ + "img/stesti-zlata-ryba-1.62a2055c.png";